import { surveyApi } from './api';

import { get, post } from '@/axiosConfig/index.js';

export default {
  saveDiagnosis(params) {
    return post(surveyApi.saveDiagnosis, params);
  },
  saveLegal(params) {
    return post(surveyApi.saveLegal, params);
  },
  save(params) {
    return post(surveyApi.save, params);
  },
  getConfigInfo(params) {
    return get(surveyApi.getConfigInfo, params);
  },
};
